function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #010101;\n        fill-rule: evenodd;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "f_eyebrowshape_s_vector-2",
  "data-name": "f_eyebrowshape_s_vector",
  className: "cls-2",
  d: "M450.219,276c19.832-.379,29.941,4.615,34.765,18.75-6.862-5.027-13.454-7.735-24.218-9.375-13-1.981-25.259,7.884-37.11,1.172-0.736-2.5-1.7-5.242-.39-7.813l0.781-.781C430.282,274.269,443.433,278.818,450.219,276Zm-110.938.391c6.61-.08,33.725.018,36.719,1.562,0.292,3.788.475,7.752-2.344,9.375-9.527,8.115-25.887-3.05-38.281-.781-9.17,1.679-15.337,6.083-22.266,9.375,3.776-6.941,10.3-14.943,17.969-17.969Z"
});

var SvgFEyebrowshapeSVector = function SvgFEyebrowshapeSVector(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f_eyebrowshape_s_vector",
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFEyebrowshapeSVector, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/f_eyebrowshape_s_vector.0c3dc5df.svg";
export { ForwardRef as ReactComponent };